import { Alert, Button, Popconfirm, Space, Table, Typography } from "antd";
import { useTranslation } from "react-i18next";
import ApiService from "../../core/service/api-service";
import ArtifactUploadButton from "./ArtifactUploadButton";
import ArtifactDownloadButton from "./ArtifactDownloadButton";
import { KIND_FFMPEG, byKind, formatBytes, formatDate } from "./artifact-utils";

/** FFmpeg paketleri sürümsüzdür: platform başına tek dosya, istemci yoksa indirir. */
export default function FFmpegTab({ settings, reload }) {
    const { t } = useTranslation();
    const platforms = settings.platforms ?? [];
    const artifacts = byKind(settings.artifacts, KIND_FFMPEG);

    const remove = async (platform) => {
        const response = await ApiService.ViewerSettings.DeleteArtifact(KIND_FFMPEG, 0, platform);
        if (response?.success) reload();
    };

    const rows = platforms.map(platform => ({
        key: platform.key,
        platform,
        artifact: artifacts.find(x => x.platform === platform.key)
    }));

    const columns = [
        { title: t('Platform'), key: 'platform', render: (_, row) => row.platform.displayName },
        {
            title: t('Size'),
            key: 'size',
            render: (_, row) => row.artifact ? formatBytes(row.artifact.size) : <Typography.Text type="secondary">—</Typography.Text>
        },
        {
            title: t('Uploaded At'),
            key: 'uploadedAt',
            render: (_, row) => formatDate(row.artifact?.uploadedAt)
        },
        {
            title: '',
            key: 'actions',
            render: (_, row) => (
                <Space>
                    {row.artifact && <ArtifactDownloadButton artifact={row.artifact} />}
                    <ArtifactUploadButton
                        size="small"
                        label={row.artifact ? t('Replace') : t('Upload zip')}
                        upload={(file, onProgress) => ApiService.ViewerSettings.UploadFFmpeg(row.platform.key, file, onProgress)}
                        onUploaded={reload}
                    />
                    {row.artifact && (
                        <Popconfirm title={t('Delete this package?')} onConfirm={() => remove(row.platform.key)}>
                            <Button size="small" danger>{t('Delete')}</Button>
                        </Popconfirm>
                    )}
                </Space>
            )
        }
    ];

    return (
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
            <Alert
                type="info"
                showIcon
                message={t('FFmpeg is downloaded once per workstation, only when it is missing. There is no version tracking.')}
            />
            <Table rowKey="key" size="small" pagination={false} dataSource={rows} columns={columns} />
        </Space>
    );
}
